import React, { useEffect, useRef, useState } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import Logo from "./assets/logo.png";
import { HiOutlineBars3 } from "react-icons/hi2";
import { Icon } from "@iconify/react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import $ from "jquery";

function Navbar() {
  const [maintoggle, setmainToggle] = useState(false);

  function animation() {
    var tabsNewAnim = $("#navbarSupportedContent");
    var activeItemNewAnim = tabsNewAnim.find(".active");
    var activeWidthNewAnimHeight = activeItemNewAnim.innerHeight();
    var activeWidthNewAnimWidth = activeItemNewAnim.innerWidth();
    var itemPosNewAnimTop = activeItemNewAnim.position();
    var itemPosNewAnimLeft = activeItemNewAnim.position();
    $(".hori-selector").css({
      top: itemPosNewAnimTop.top + "px",
      left: itemPosNewAnimLeft.left + "px",
      height: activeWidthNewAnimHeight + "px",
      width: activeWidthNewAnimWidth + "px",
    });
    $("#navbarSupportedContent").on("click", "li", function (e) {
      $("#navbarSupportedContent ul li").removeClass("active");
      $(this).addClass("active");
      var activeWidthNewAnimHeight = $(this).innerHeight();
      var activeWidthNewAnimWidth = $(this).innerWidth();
      var itemPosNewAnimTop = $(this).position();
      var itemPosNewAnimLeft = $(this).position();
      $(".hori-selector").css({
        top: itemPosNewAnimTop.top + "px",
        left: itemPosNewAnimLeft.left + "px",
        height: activeWidthNewAnimHeight + "px",
        width: activeWidthNewAnimWidth + "px",
      });
    });
  }

  // const [isSticky, setIsSticky] = useState(false);
  const navbarRef = useRef(null);

  // const handleScroll = () => {
  //   const navbar = navbarRef.current;
  //   const top = navbar.offsetTop;
  //     setIsSticky(window.scrollY >= top);
  // };

  useEffect(() => {
    animation();
    $(window).on("resize", function () {
      setTimeout(function () {
        animation();
      }, 500);
    });
    // window.addEventListener("scroll", handleScroll);
    // return () => {
    //   window.removeEventListener("scroll", handleScroll);
    // };
  }, []);

  useEffect(() => {
    let handler = (e) => {
      const navbar = navbarRef.current;
      if (!navbar.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
  }, []);

  const [open, setOpen] = useState(false);
  return (
    <nav
      className="sticky navbar navbar-expand-lg navbar-mainbg"
      ref={navbarRef}
      style={{
        paddingRight: "5%",
      }}
    >
      <Link
        className="navbar-brand navbar-logo"
        to="/"
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        <img src={Logo} alt="" />
      </Link>

      <div
        className="collapse navbar-collapse"
        id="navbarSupportedContent"
        style={{
          justifyContent: "end",
          width: "100%",
        }}
      >
        <ul className="navbar-nav ml-auto">
          <div className="hori-selector">
            <div className="left"></div>
            <div className="right"></div>
          </div>

          <li className="nav-item active">
            <Link className="nav-link" to="/#home">
              Home
            </Link>
          </li>

          <li className="nav-item">
            <Link className="nav-link" to="/#about">
              About Me
            </Link>
          </li>

          <li className="nav-item">
            <Link className="nav-link" to="/#work">
              Experience
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/#research">
              Research
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/#projects">
              Projects
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/#contact">
              Contact
            </Link>
          </li>
        </ul>
      </div>

      <div className="navbar-menu-container">
        <HiOutlineBars3
          onClick={() => {
            setOpen(!open);
          }}
          className="hamburger"
        />
      </div>

      <div>
        <div
          className={`navbar-drawer ${open ? "active" : "inactive"}`}
          style={{ overflowY: "auto" }}
        >
          <div className="sidebar-logo">
            <Link className="navbar-brand navbar-logo" to="/">
              <img src={Logo} alt="" />
            </Link>
          </div>
          <ul>
            <div className="item">
              <li
                onClick={() => {
                  setOpen(false);
                }}
              >
                <Link to="/#home">
                  <Icon icon="material-symbols:home" className="navbar-icon" />
                  Home
                </Link>
              </li>
            </div>
            <li
              onClick={() => {
                setOpen(false);
              }}
            >
              <Link to="/#about">
                <Icon icon="material-symbols:person" className="navbar-icon" />
                About Me
              </Link>
            </li>
            <li
              onClick={() => {
                setOpen(false);
              }}
            >
              <Link to="/#work">
                <Icon icon="raphael:pc" className="navbar-icon" />
                Work
              </Link>
            </li>

            <li
              onClick={() => {
                setOpen(false);
              }}
            >
              <Link to="/#research">
                <Icon
                  icon="game-icons:archive-research"
                  className="navbar-icon"
                />
                Research
              </Link>
            </li>
            <li>
              <Link
                to="/#projects"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <Icon icon="eos-icons:project" className="navbar-icon" />
                Projects
              </Link>
              <div
                onClick={() => {
                  setmainToggle(!maintoggle);
                }}
                style={{ paddingRight: "49px" }}
              >
                {maintoggle ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </div>
            </li>
            {maintoggle && (
              <ul>
                <li>
                  <Link to="/#amazon">
                    <Icon icon="dashicons:amazon" className="navbar-icon" />
                    Amazon Clone
                  </Link>
                </li>
                <li>
                  <Link to="/#news">
                    <Icon icon="arcticons:top-news" className="navbar-icon" />
                    News Application
                  </Link>
                </li>
                <li>
                  <Link to="/#chat">
                    <Icon
                      icon="fluent:chat-20-regular"
                      className="navbar-icon"
                    />
                    Chat Application
                  </Link>
                </li>
                <li>
                  <Link to="/#weather">
                    <Icon icon="ph:sun-light" className="navbar-icon" />
                    Weather App
                  </Link>
                </li>
                <li>
                  <Link to="/#game">
                    <Icon icon="arcticons:2048" className="navbar-icon" />
                    2048 Game
                  </Link>
                </li>
                <li>
                  <Link to="/#dynamic">
                    <Icon icon="iconoir:www" className="navbar-icon" />
                    Dynamic Site
                  </Link>
                </li>
              </ul>
            )}

            <li
              onClick={() => {
                setOpen(false);
              }}
            >
              <Link to="/#contact">
                <Icon
                  icon="material-symbols:phone-enabled-sharp"
                  hFlip={true}
                  className="navbar-icon"
                />
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
export default Navbar;
